// src/context/UserContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { fetchUser } from "../services/api"; // should use axios instance that auto-attaches Bearer token

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);

  const reloadUser = async () => {
    setLoadingUser(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setUser(null);
        return;
      }
      // No need to pass token; axios instance attaches it
      const res = await fetchUser();
      if (res.status === 200 && res.data?.user) {
        setUser(res.data.user);
      } else {
        setUser(null);
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        // expired/invalid token
        setUser(null);
      } else {
        console.error("Failed to fetch user:", err);
        setUser(null);
      }
    } finally {
      setLoadingUser(false);
    }
  };

  useEffect(() => {
    reloadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutLocal = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  const value = {
    user,
    setUser,             // optional: if you want to set after profile edits
    isLoggedIn: !!user,  // <- what ProductDetailPage checks
    loadingUser,         // <- to avoid redirect during auth load
    reloadUser,          // <- for silent refresh after login
    logoutLocal,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
